export default __webpack_public_path__ + "images/loggedout/review-images/review1-6945287935d9ab706168272116631183.svg";